import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Grid } from "@mui/material";
import { createCommercial } from "../../../services";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import { verificarNif, verificarCorreo } from "../../../functions/validator/formValidator";



const NuevoComercial = () => {
  const { t } = useTranslation('common');
  const [comercial, setComercial] = useState({});

  async function handleSubmit(data) {
    const toastInfo = toast.info(t('commercials.messages.saving'));

    let nifCorrecto = verificarNif(data.nif);
    let correoCorrecto = verificarCorreo(data.email);
    let errores = false;

    if (Object.keys(data).length === 0) {
      toast.update(toastInfo, {
        render: t('commercials.messages.emptyCommercial'),
        type: toast.TYPE.ERROR,
        autoClose: true,
      });
      errores = true;
    } else {
      if (nifCorrecto === false && data.nif !== undefined) {
        toast.dismiss(toastInfo);
        toast.error(t('commercials.messages.incorrectNif'));
        errores = true;
      }

      if (correoCorrecto === false && data.email !== undefined) {
        toast.dismiss(toastInfo);
        toast.error(t('commercials.messages.incorrectEmail'));
        errores = true;
      }

      const requiredFields = ['email', 'nif', 'nombre', 'apellidos'];
      for (const field of requiredFields) {
        if (!data[field]) {
          toast.dismiss(toastInfo);
          toast.error(t('commercials.messages.emptyField'));
          errores = true;
          break;
        }
      }

      if (!errores) {
        
        try {
          let res = await createCommercial(data);

          if (res.status === 201) {
            toast.update(toastInfo, {
              render: t('commercials.messages.createdSuccess'),
              type: toast.TYPE.SUCCESS,
              autoClose: true,
            });

            window.location.replace("/comerciales");
          } else if (res.status === 202) {
            toast.update(toastInfo, {
              render: t('commercials.messages.createError'),
              type: toast.TYPE.ERROR,
              autoClose: true,
            });
          }
          if(res.status === 403){
            toast.update(toastInfo, {
              render: t('commercials.messages.alreadyExists'),
              type: toast.TYPE.ERROR,
              autoClose: true,
            });
          }
          

        } catch (err) {

          toast.update(toastInfo, {
            render: t('messages.error'),
            type: toast.TYPE.ERROR,
            autoClose: true,
          });

        }
      }
    }
  }


  function handleChange(evt) {
    const value = evt.target.value;
    setComercial({
      ...comercial,
      [evt.target.name]: value,
    });
  }

  return (
    <>
      {/* <div
        className="pageHeader"
        style={{
          backgroundImage: `url(${HeaderBackground})`,
          textAlign: "left",
        }}
      >
        Comerciales / <b>Nuevo</b>
      </div> */}
      <BreadCrumb rutas={[{ path: `/comerciales`, label: t('commercials.title') }, { path: `/comerciales`, label: t('commercials.new') }]} style={{ margin: '0 10px' }} />
      <div className="pageContent">
        <div className="gridHead">{t('commercials.createNew')}</div>
        <form className="nuevoAAFFForm">
          <Grid
            container
            spacing={5}
            style={{ marginTop: 20, marginBottom: 20 }}
          >
            <Grid item xs={12} sm={6}>
              <input
                type="text"
                required
                placeholder={t('form.nif')}
                name="nif"
                value={comercial.nif}
                onChange={handleChange}
                pattern="(^[0-9]{8}[A-Z]{1})$|^([A-Z]{1}[0-9]{8})$|^([A-Z]{1}[0-9]{7}[A-Z]{1}$)"
                title={t('form.nif')}
              ></input>
            </Grid>
            <Grid item xs={12} sm={6}>
              <input
                type="email"
                required
                placeholder={t('form.email')}
                name="email"
                value={comercial.email}
                onChange={handleChange}
              ></input>
            </Grid>
            <Grid item xs={12} sm={6}>
              <input
                type="text"
                required
                placeholder={t('form.firstName')}
                name="nombre"
                value={comercial.nombre}
                onChange={handleChange}
              ></input>
            </Grid>
            <Grid item xs={12} sm={6}>
              <input
                type="text"
                required
                placeholder={t('form.lastName')}
                name="apellidos"
                value={comercial.apellidos}
                onChange={handleChange}
              ></input>
            </Grid>
          </Grid>
          <input
            type="button"
            value={t('actions.save')}
            onClick={() => handleSubmit(comercial)}
          ></input>
        </form>
      </div>
    </>
  );
};

export default NuevoComercial;
